<template>
  <div>
    <div class="spelling-container">
      <div v-if="joined"
           class="spelling-now-box">
        <div class="spelling-now"
             @click="viewMyGroup">
          <div class="text">您已参与拼团啦～，查看拼团详情</div>
          <div class="more"></div>
        </div>
      </div>
      <div v-else>
        <div v-if="organizerNum > 0 "
             class="spelling-now-box">
          <group-scroller :organizers="organizers"></group-scroller>
          <div class="spelling-now">
            <div class="text">{{organizerNum}}人正在拼团，可直接参与</div>
            <div @click="groupBuyList"
                 class="more">更多<img class="more-arrow"
                   src="../../assets/icons/more_green.png" /></div>
          </div>
        </div>
        <div class="spelling-rules-box spelling-rules-todetail">
          <div class="title">
            <div class="text">拼团玩法</div>
            <div class="more"
                 @click="viewGroupRule">详细规则<img class="more-arrow"
                   src="../../assets/icons/more_orange.png" /></div>
          </div>
          <div class="rules">开团/参团 > 邀请好友 > 满员发货（不满自动退款）</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import groupScroller from './groupScroller.vue'
import axios from "axios"

export default {
  props: ["activity"],
  components: {
    groupScroller
  },
  data() {
    return {
      organizerNum: 0,
      groupOrder: {},
      joined: false,
      organizers: [],
    }
  },
  async created() {
    const { data } = await axios.get(`/api/goods/order/old/group/groupHomeOrganizer`, { params: { activity_id: this.activity.id } })
    this.organizerNum = data.organizer_total
    this.joined = data.verify_result && data.verify_result.joined
    this.groupOrder = data.verify_result && data.verify_result.group
    this.organizers = data.organizers
    this.$emit('updateGroup', {
      joined: this.joined
    })
  },
  methods: {
    viewMyGroup() {
      window.location.href = `//${window.location.host}/center/groupView?orgId=${this.groupOrder.group_order_id}`
    },
    async viewGroupRule() {
      if (this.activity.rule_pic) {
        window.location.href = `//${window.location.host}/goods/picPage?src=${this.activity.rule_pic}`
      }
    },
    groupBuyList() {
      this.$router.push(`/groupList?activityId=${this.activity.id}`)
    }
  }

}
</script>
<style lang="less">
@import (reference) url("../../common.less");
.spelling-container {
  padding: 0 0.88rem 0.88rem;
  background: white;
  .spelling-now-box {
    .spelling-now {
      .cells;
      align-items: center;
      height: 2.29rem;
      padding: 0 0.88rem;
      background-image: linear-gradient(
        90deg,
        rgba(120, 220, 80, 0.08) 0%,
        rgba(60, 200, 100, 0.08) 100%
      );
      border-radius: 0.35rem;
      .text {
        flex: 1;
        font: 0.76rem/2.29rem @fontStack;
        color: @text1;
      }
      .more {
        font-size: 0.71rem;
        color: #00b097;
        .link;
        .more-arrow {
          margin-left: 0.29rem;
          width: 0.29rem;
          height: 0.53rem;
        }
      }
    }
  }
  .spelling-rules-box {
    padding: 0 1.59rem 0 1.06rem;
    background-color: #fff;
    .title {
      .cells;
      align-items: center;
      height: 1.32rem;
      .text {
        flex: 1;
        font: 0.94rem/1.32rem @fontStack;
        color: @text1;
        font-weight: bold;
      }
    }
    .rules {
      padding-top: 0.76rem;
      font: 0.76rem/1.09rem @fontStack;
      color: @text2;
    }
  }
  .spelling-rules-box.spelling-rules-todetail {
    background-color: #fff;
    padding: 1.06rem 0.88rem;
    .more {
      font-size: 0.71rem;
      color: @groupCommonColor;
      .link;
      .more-arrow {
        margin-left: 0.29rem;
        width: 0.29rem;
        height: 0.53rem;
      }
    }
  }
}
</style>
